export default [
    {
        path: 'cancelamento-evasao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-cancelamento-evasao' */
            '@/views/pronto-atendimento/cancelamento-evasao/Index'
        ),
        redirect: 'cancelamento-evasao/index',
        children: [
            {
                name: 'pronto-atendimento-cancelamento-evasao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-cancelamento-evasao' */
                    '@/views/pronto-atendimento/cancelamento-evasao/List.vue'
                ),
            },
        ],
    },
]